module.exports = __webpack_public_path__ + "img/gift_me.f066080c.jpg";